import { cn } from '@/lib/cn'
import { tierIcon, tierTint } from '@/lib/tiers'

/** Tinted tier chip - Badge's look, but colored from the tier's own hex. */
export default function TierBadge({
  name,
  color,
  icon,
  className,
}: {
  name: string
  color?: string | null
  icon?: string | null
  className?: string
}) {
  const Icon = tierIcon(icon)
  return (
    <span
      className={cn('inline-flex items-center gap-1 rounded-lg border px-2 py-0.5 text-xs font-semibold', className)}
      style={tierTint(color)}
    >
      <Icon className="size-3" />
      {name}
    </span>
  )
}
